import React from 'react';

import { Box } from '@mui/material';
import PropTypes from 'prop-types';

import { scrollableContentStyles } from './ScrollableTooltipContent.styles';

const ScrollableTooltipContent = ({ children, header = null, footer = null }) => {
  return (
    <Box sx={scrollableContentStyles.wrapper}>
      {header && <Box sx={scrollableContentStyles.header}>{header}</Box>}

      <Box
        aria-label="Scrollable content"
        role="region"
        sx={scrollableContentStyles.content}
        tabIndex={0}
      >
        {children}
      </Box>

      {footer && <Box sx={scrollableContentStyles.footer}>{footer}</Box>}
    </Box>
  );
};

ScrollableTooltipContent.propTypes = {
  children: PropTypes.node.isRequired,
  header: PropTypes.node,
  footer: PropTypes.node,
};

export default ScrollableTooltipContent;
